export default "__VITE_ASSET__DEG73kWE__"